import JwtService from "@/common/jwt.service";

// Admin "Login as customer" lands here as ?token=<customer token>&admin_user_id=<admin id>.
//
// Taken HERE — before the router is installed and before its guard ever runs — not in Home.vue's
// created(). The guard runs first, and when the browser still held a previous session (another
// customer's token and cached profile) it started a user-profile call with that OLD token. If the
// old token had expired, CHECK_AUTH's failure handler destroyed the token Home.vue had just saved
// and reloaded: the first "Login" ended logged out and the second worked. If it was still valid, its
// answer could land after the new one and show the previous customer instead.
//
// So the old token and its cached profile are cleared, the new token saved, and the two parameters
// stripped from the address before the router reads it.
//
// A module of its own, imported FIRST by main.js, because "before the router reads it" means before
// ./router is even imported: createWebHistory() captures the address the moment router/index.js is
// evaluated, and its initial navigation writes that captured address back — token and all — so
// stripping it from main.js's own body, after the imports, was too late.
function adoptAdminLoginToken() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) return;

    JwtService.destroyToken();
    JwtService.saveToken(token);
    window.localStorage.setItem("adminLoggedIn", true);
    const adminUserId = params.get("admin_user_id");
    if (adminUserId) {
        window.localStorage.setItem("admin_user_id", adminUserId);
    } else {
        window.localStorage.removeItem("admin_user_id");
    }

    params.delete("token");
    params.delete("admin_user_id");
    const query = params.toString();
    window.history.replaceState(
        window.history.state,
        "",
        window.location.pathname +
            (query ? `?${query}` : "") +
            window.location.hash
    );
}

adoptAdminLoginToken();
